<div *ngIf="sendedAnyInvite" class="d-flex text-light-shadow-v2 mt-7">
    <div class="icon icon-2 me-3 ms-4 icon-white" inlineSVG="assets/icons.svg#invite-success"></div>
    <div class="d-flex flex-column invites-info">
        <div class="font-bold text-s">{{ 'v3-leaderboard-trial-invites-sent' | translate: { invites: (invitesSent$ | async) } }}</div>
        <div class="text-s" translate>v3-leaderboard-trial-sended-invites</div>
    </div>
</div>

<div *ngIf="!sendedAnyInvite" class="d-flex align-items-center invite-users-box rounded mt-1 h-100">
    <div class="d-flex text-light-shadow-v2">
        <div class="icon icon-xxxl me-4 ms-4" inlineSVG="assets/icons-color.svg#invite"></div>
        <div class="d-flex flex-column invites-info">
            <div class="text-xs" translate>v3-leaderboard-trial-get-more</div>
            <div class="text-xs">{{ 'v3-leaderboard-trial-invite-up' | translate: { colleagues: (invitesMax$ | async) } }}</div>
        </div>
    </div>
</div>
